import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PolicyReader, { PolicyLanguagePicker, PolicyDownload } from '../components/legal/PolicyReader';
import { initialPolicyLanguage, savePolicyLanguage, policyCopy } from '../legal/policy';

// Public, read-only document. Opening it is never recorded as consent.
export default function PrivacyPolicyPage() {
  const [params, setParams] = useSearchParams();
  const [initial] = useState(() => initialPolicyLanguage(params.get('lang')));
  const language = params.has('lang') ? initialPolicyLanguage(params.get('lang') || 'invalid') : initial;
  const changeLanguage = value => {
    savePolicyLanguage(value);
    const next = new URLSearchParams(params); next.set('lang', value);
    setParams(next, { replace: true });
    window.scrollTo(0, 0);
  };
  return <main className="legal-policy-page" lang={language}>
    <div className="legal-page-top"><Link className="ap-button" to="/login"><ArrowLeft size={16} aria-hidden="true" />{policyCopy[language].back}</Link><PolicyDownload language={language} /></div>
    <div className="legal-page-card"><PolicyLanguagePicker language={language} onChange={changeLanguage} /><PolicyReader language={language} /></div>
  </main>;
}
